<template>
  <div class="partnet-point-logs">
    <p v-if="fetching">
      <Loading />
    </p>
    <template v-else>

      <Tabs />

      <div class="partnet-point-logs__filters d-flex justify-content-between">
        <button v-b-modal.modal-filter-type>{{ filterType }}

          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M12.5303 5.46967C12.8232 5.76256 12.8232 6.23744 12.5303 6.53033L8.53033 10.5303C8.38968 10.671 8.19891 10.75 8 10.75C7.80109 10.75 7.61032 10.671 7.46967 10.5303L3.46967 6.53033C3.17678 6.23744 3.17678 5.76256 3.46967 5.46967C3.76256 5.17678 4.23744 5.17678 4.53033 5.46967L8 8.93934L11.4697 5.46967C11.7626 5.17678 12.2374 5.17678 12.5303 5.46967Z"
              fill="#666666" />
          </svg>

        </button>

        <button v-b-modal.modal-filter-date>{{ filterDate }}
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M12.5303 5.46967C12.8232 5.76256 12.8232 6.23744 12.5303 6.53033L8.53033 10.5303C8.38968 10.671 8.19891 10.75 8 10.75C7.80109 10.75 7.61032 10.671 7.46967 10.5303L3.46967 6.53033C3.17678 6.23744 3.17678 5.76256 3.46967 5.46967C3.76256 5.17678 4.23744 5.17678 4.53033 5.46967L8 8.93934L11.4697 5.46967C11.7626 5.17678 12.2374 5.17678 12.5303 5.46967Z"
              fill="#666666" />
          </svg>

        </button>
      </div>

      <div class="s-p-3">

        <div class="s-bg-white rounded rounded-2 d-flex align-items-center s-p-3 s-mb-3 partnet-point-logs__card">
          <img src="./images/image-4.png" alt="" class="s-mr-3">
          <div class="s-text-xs">數位會員卡 2770012345678</div>
        </div>


        <div v-for="i in 30" :key="i" class="s-bg-white s-mb-3 partnet-point-logs__log">
          <div class="d-flex justify-content-between align-items-center s-mb-2">
            <div class="partnet-point-logs__log__title">{{ log.title }}</div>
            <div class="s-text-secondary partnet-point-logs__log__desc">{{ log.point }}</div>
          </div>
          <div class="d-flex align-items-center justify-content-between">
            <div class="partnet-point-logs__log__desc">
              <div>兌換序號：{{ log.sn }}</div>
              <div>兌換序號：{{ log.expired_at }}</div>
            </div>

            <div>
              <button class="s-btn s-btn-primary s-btn-sm s-text-xs w-auto text-nowrap py-2 px-3"
                v-b-tooltip.click="'已複製'">複製</button>
            </div>
          </div>
        </div>
      </div>


      <b-modal id="modal-filter-type" centered>

        <template #modal-header="{ close }">


          <div>選擇查詢分類</div>
          <!-- Emulate built in modal header close button action -->
          <b-button variant="link" @click="close()" class="close">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6.4 19L5 17.6L10.6 12L5 6.4L6.4 5L12 10.6L17.6 5L19 6.4L13.4 12L19 17.6L17.6 19L12 13.4L6.4 19Z"
                fill="#666666" />
            </svg>

          </b-button>


        </template>

        <div class="px-3 pt-3">

          <b-form-radio v-for="(i, idx) in filterOptions.type" v-model="filterType" :key="idx" :value="i"
            class="mb-3">{{ i
            }}</b-form-radio>

        </div>

        <template #modal-footer="{ close }">
          <div class="w-100">
            <button class="s-btn s-btn-primary s-btn-sm px-4" @click="close()">確認</button>
          </div>
        </template>
      </b-modal>


      <b-modal id="modal-filter-date" centered>

        <template #modal-header="{ close }">


          <div>選擇查詢區間</div>
          <!-- Emulate built in modal header close button action -->
          <b-button variant="link" @click="close()" class="close">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6.4 19L5 17.6L10.6 12L5 6.4L6.4 5L12 10.6L17.6 5L19 6.4L13.4 12L19 17.6L17.6 19L12 13.4L6.4 19Z"
                fill="#666666" />
            </svg>

          </b-button>


        </template>

        <div class="px-3 pt-3">

          <b-form-radio v-for="(i, idx) in filterOptions.date" v-model="filterDate" :key="idx" :value="i"
            class="mb-3">{{ i
            }}</b-form-radio>

        </div>

        <template #modal-footer="{ close }">
          <div class="w-100">
            <button class="s-btn s-btn-primary s-btn-sm px-4" @click="close()">確認</button>
          </div>
        </template>
      </b-modal>

    </template>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import Loading from '@/components/Page/Liff/Shared/Loading'
import list from '@/mixins/liff/memberCard/list'
import Tabs from '@/components/Page/Liff/MemberCard/PartnetPoint/Tabs.vue';

export default {
  mixins: [list],
  components: { Loading, Tabs },
  data: () => ({
    filterType: '全部',
    filterDate: '最近6個月',
    log: {
      title: '亞洲萬里通 100 哩程',
      sn: "POLB4NYFZSQPX2PU1",
      expired_at: "2025/12/31",
      point: "-1,000",
    },
    filterOptions: {
      type: [
        "全部",
        "兌換 POYA 點數",
        "兌換異業點數",
      ],
      date: [
        "最近1個月",
        "最近3個月",
        "最近6個月"
      ]
    }
  }),
  methods: {
    ...mapActions({
      getTransactions: 'liffMemberCard/getTransactions',
    }),
    async fetch() {

    },

  }
}
</script>

<style lang="scss" scoped>
.partnet-point-logs {
  margin: -1rem -0.75rem 0;

  &__filters {

    background-color: white;
    border-top: 1px solid #E3E3E3;

    font-weight: 500;
    font-size: 14px;
    padding: 12px;


    button {
      display: flex;
      align-items: center;
      gap: 4px;
    }
  }

  &__card {
    img {
      width: 30px;
    }
  }

  &__log {
    padding: 12px;

    &__title {
      font-weight: 500;
      font-size: 16px;
      color: #333333;
    }

    &__point {
      font-weight: 500;
      font-size: 14px;      
    }

    &__desc {

      font-weight: 500;
      font-size: 12px;
      color: #999999;

    }
  }
}



.s-text-secondary {
  color: #FE577F !important;
}


::v-deep .modal-backdrop {
  opacity: .5;
}

::v-deep .modal {

  --s-primary: #FE577F;


  &.fade .modal-dialog {
    transform: translateY(10%);
    transition: transform 0.3s ease-out;
  }

  &.show .modal-dialog {
    transform: translateY(0);
  }


  .modal-dialog {

    margin: auto;

    .modal-header {
      justify-content: center;
      align-items: center;
      position: relative;

      .close {
        position: absolute;
        right: 0;
        margin: 0;
      }
    }

    .modal-content {
      border-radius: .3rem .3rem 0 0;
      border: none;
    }

    &.modal-dialog-centered {
      align-items: end;

      min-height: calc(100%);
     
    }
  }

  .s-btn {
    color: white !important;
  }


}
</style>
